/**
 * Beyond Session Delivery Type based on Docebo learning paths
 */
export enum SessionDeliveryType {
  IN_PERSON = 'Instructor-Led (In-Person)',
  VIRTUAL = 'Instructor-Led (Virtual)',
}
